import { lazy } from 'react';

const PaymentTermsCompliance = lazy(() =>
  import('../pages/PaymentTermsCompliance/index.js').then((module) => ({
    default: module.PaymentTermsCompliance,
  })),
);

const paymentTermsComplianceRoute = {
  public: [],
  auth: [
    {
      name: 'payment_terms_compliance',
      path: '/credit-and-collections/management/payment-terms-compliance',
      component: PaymentTermsCompliance,
    },
  ],
};

export default paymentTermsComplianceRoute;
